import React from 'react';
import { Spin, Table } from 'antd';
import type { TableProps, PaginationProps } from 'antd';
import Pagination from '@/components/ptx-pagination';
import CardList from './card-list';
import type { EmptyProps } from '@/components/ptx-empty';
import PtxEmpty from '@/components/ptx-empty';

declare type OverlayFunc = () => React.ReactElement;

interface IEmptyProps extends EmptyProps {
  isEmpty: boolean;
}

interface ICardProps<T> {
  titleKey: string;
  imageUrl?: (item: T) => string;
  subTitle?: (item: T) => React.ReactNode;
  defaultIcon?: (item?: T) => React.ReactNode;
  onClick?: (item: T) => void;
  renderMenu?: (item: T) => React.ReactElement | OverlayFunc;
  renderTitle?: (item: T) => React.ReactElement | OverlayFunc;
  hasBrow?: boolean;
  itemBoxStyle?: React.CSSProperties | undefined;
  itemStyle?: React.CSSProperties | undefined;
}

interface PtxTableProps<RecordType> extends TableProps<RecordType> {
  showType: number; // 0: 卡片列表， 1: 普通列表
  pagination: false | PaginationProps;
  empty: IEmptyProps;
  cardInfo?: ICardProps<RecordType>;
  noBorder?: boolean;
  choiceMode?: boolean;
  disabledKeys?: React.Key[];
}

const PtxTable: React.FC<PtxTableProps<any>> = (props) => {
  const {
    showType,
    pagination,
    empty: { show, ...emptyProps },
    cardInfo,
    dataSource,
    rowSelection, // 卡片的选中用法同列表的
    loading,
    noBorder,
    choiceMode = false,
    disabledKeys,
    ...tableProps
  } = props;

  return (
    <>
      {loading ? (
        <div style={{ width: '100%', height: '100%' }} className="flex-jc-ai-center">
          <Spin spinning={true} />
        </div>
      ) : show ? (
        <PtxEmpty {...emptyProps} />
      ) : (
        <>
          <div className="pageTable">
            {showType == 1 ? (
              <Table
                {...tableProps}
                loading={loading}
                className={noBorder ? '' : 'list-table'}
                rowSelection={rowSelection}
                dataSource={dataSource}
                rowKey={tableProps.rowKey || 'id'}
                sticky={true}
                pagination={false}
              />
            ) : (
              <Spin spinning={loading as boolean}>
                <CardList
                  choiceMode={choiceMode}
                  rowKey={tableProps.rowKey || 'id'}
                  rowSelection={rowSelection}
                  dataSource={dataSource || []}
                  disabledKeys={disabledKeys}
                  {...(cardInfo || {})}
                />
              </Spin>
            )}
          </div>
          <div className="pagePagination">
            <Pagination
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `共 ${total} 条`}
              {...pagination}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PtxTable;
